<!-- 经典视频 -->
<template>
    <div>
       <sub-banner id="id_about">
        <img src="../../assets/images/video/video_banner.jpg"/>
      </sub-banner>

      <div class="video_info">
          <div class="video_content">
              <div class="video_content_item" v-for="item in videoList" :key="item.id" @click="watchVideo(item)">
                  <div class="video_img">
                      <!-- <img src="../../assets/images/video/video_one.png" /> -->
                      <img :src="item.showImgUrl" />

                  </div>
                  <div class="video_desc">
                      <div class="desc_titles">{{item.title}}</div>
                      <div class="desc_dates">
                       <div class="operator">术者： {{item.operator}}</div> 
                       <div class="hostipal">医院： {{item.hospitalName}}</div> 
                       <div class="dates">{{item.publishDate}}</div> 
                      </div>
                      <div class="desc_content">
                          {{item.abstracts}}
                      </div>
                  </div>
              </div>
              <div class="more_s" v-if="!isHiddedMore">
                <div class="more_c">
                   <div class="more_btn" @click="moreClick()">{{$t('indexText.more')}}</div>
                </div>
              </div>
          </div>
          
      
      </div>
      <el-dialog title="视频回放" :visible.sync="dialogVideoVisible" width="70%" class="customer_video_dialog" @close="closeVideoDialog" >
        <!-- <video :src="videoUrl"
         @play="onPlayerPlay"
                  @pause="onPlayerPause"
                  autoplay="autoplay"
                  ref="video"
                  webkit-playsinline="true"
                  playsinline="true"
                  x-webkit-airplay="allow"
                  x5-playsinline
                ></video> -->
                <video-player
                class="video-player vjs-custom-skin"
                ref="videoPlayer"
                name="videoPlayer"
                id="video"
                :playsinline="true"
               
                :options="playerOptions"
                @play="onPlayerPlay($event)"
                @pause="onPlayerPause($event)"
                @ended="onPlayerEnded($event)"
                @waiting="onPlayerWaiting($event)"
                @timeupdate="onPlayerTimeupdate($event)"
                @statechanged="playerStateChanged($event)"
                @canplaythrough="onPlayerCanplaythrough($event)"
                @ready = "playerReadied"
        ></video-player>
      </el-dialog>
    </div>
</template>

<script>

import { videoPlayer } from "vue-video-player";
import SubBanner from "@/components/sub-banner";
import{getClassicVideo} from '../../service/service.js'
export default {
  name: 'concat',
  metaInfo () {
    return {
      title: this.pageTitle,
      meta:[{
        name:this.metaName,
        content:this.metaContent,
        keyword:this.keyword,
        description:this.description
      }]
    }
  },
  components: {SubBanner,videoPlayer},
  data () {
    return {
      pageTitle: '广州市熵达贸易有限公司-经典视频',
      metaName:'广州市熵达贸易有限公司-经典视频',
      metaContent:'广州市熵达贸易有限公司-经典视频',
      keyword:'广州市熵达贸易有限公司,',
      description:'广州市熵达贸易有限公司' ,   
      form: {
        code: '',
        name: '',
        phone: '',
        needContent:'',
      },
      videoList:[],
      isHiddedMore:false,
      dialogVideoVisible:false,
      videoUrl:'',
      playerOptions: {
                    playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
                    autoplay: false, // 如果为true,浏览器准备好时开始回放。
                    muted: false, // 默认情况下将会消除任何音频。
                    loop: false, // 是否视频一结束就重新开始。
                    preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                    language: "zh-CN",
                    aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                    fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                    sources: [
                        {
                            type: "video/mp4", // 类型
                            src:
                                "xxxxxx.mp4" // url地址
                        }
                    ],
                    poster: "", // 封面地址
                    notSupportedMessage: "此视频暂无法播放，请稍后再试", // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
                    controlBar: {
                        timeDivider: true, // 当前时间和持续时间的分隔符
                        durationDisplay: true, // 显示持续时间
                        remainingTimeDisplay: false, // 是否显示剩余时间功能
                        fullscreenToggle: true // 是否显示全屏按钮
                    },
      },
    };
  },
  computed: {},
  watch: {
    '$store.state.lang': function (nval, oval) {
      let obj = {
        'en-US': 'Guangzhou entropy Da Trade Co., Ltd',
        'zh-TCC': '廣州市熵達貿易有限公司',
        'zh-CN': '广州市熵达贸易有限公司'
      }
      this.pageTitle = obj[nval]
    }
  },
  mounted(){
      this.getClassicVideo(1,4);
  },
  methods: {
    closeVideoDialog(){
      this.dialogVideoVisible=false;
      this.playerOptions.sources=[  //设置视频路径为null 暂停播放
        {  
          type: "video/mp4", // 类型
          src: null // url地址
         }
        ]
    },
    watchVideo(item){
      this.dialogVideoVisible=true;
      this.videoUrl=item.videoUrl;
      this.playerOptions.sources=[
        {  
          type: "video/mp4", // 类型
          src: this.videoUrl // url地址
         }
        ]
    },
    moreClick(){
      this.getClassicVideo(1,999999);
      this.isHiddedMore=true;
    },
    async getClassicVideo(pageNum,pageSize){
      let resp=await getClassicVideo(pageNum,pageSize);
      if(resp){
        resp.data.map((v)=>{
          v.showImgUrl=process.env.BASE_IMG_URL+v.showImgUrl
          v.videoUrl=process.env.BASE_IMG_URL+v.videoUrl
        })
        this.videoList=resp.data;
      }
    },
     // 播放回调
            onPlayerPlay(player) {
                console.log("player play!", player);
            },

            // 暂停回调
            onPlayerPause(player) {
                console.log("player pause!", player);
            },

            // 视频播完回调
            onPlayerEnded($event) {
            },
            // DOM元素上的readyState更改导致播放停止
            onPlayerWaiting(player) {
                let time = localStorage.getItem("cacheTime")
                if(player.cache_.currentTime - Number(time) > 0.1){
                    this.current = Number(time)
                    this.playerReadied(player)
                }else{
                    this.current = player.cache_.currentTime
                }
            },

            // 已开始播放回调
            onPlayerPlaying($event) {
                // console.log(player)
            },

            // 当播放器在当前播放位置下载数据时触发
            onPlayerLoadeddata($event) {
                // console.log(player)
            },

            // // 当前播放位置发生变化时触发。
            onPlayerTimeupdate(player) {
                this.playTime = player.cache_.currentTime
                let playTime = player.cache_.currentTime
                setTimeout(function () {
                    localStorage.setItem("cacheTime",playTime)
                },500)


                let time = localStorage.getItem("cacheTime")
                if(player.cache_.currentTime - Number(time) > 2){
                    this.current = Number(time)
                    this.playerReadied(player)
                }else{
                    this.current = player.cache_.currentTime
                }
            },

            //媒体的readyState为HAVE_FUTURE_DATA或更高
            onPlayerCanplay(player) {
                // console.log('player Canplay!', player)
            },

            //媒体的readyState为HAVE_ENOUGH_DATA或更高。这意味着可以在不缓冲的情况下播放整个媒体文件。
            onPlayerCanplaythrough(player) {
                // console.log('player Canplaythrough!', player)
            },

            //播放状态改变回调
            playerStateChanged(playerCurrentState) {
                // console.log('player current update state', playerCurrentState)
            },

            //将侦听器绑定到组件的就绪状态。与事件监听器的不同之处在于，如果ready事件已经发生，它将立即触发该函数。。
            playerReadied(player) {
                // console.log('example player 1 readied', player);
                player.currentTime(this.current)
            }
   
  },
  
  created () {

  },
}
</script>
<style lang='scss' scoped>
.video_info{
    width:100%;
    background:#fff;
    .video_content{
        width:70%;
        margin:auto;
        padding:120px 0px; 
        .video_content_item{
            display: flex;
            justify-content: center;
            align-items: center;
            margin-bottom:80px;
            .video_img{
                // width:268px;
                // height: 165px;
                img{
                    width:100%;
                    height: 100%;
                }
            }
            .video_desc{
                width: 875px;
                margin-left:43px;
                display: flex;
                justify-content: flex-start;
                align-items: flex-start;
                flex-direction: column;
                cursor: pointer;
                .desc_titles{
                    color:#333333;
                    font-size: 18px;
                    font-weight: bold;
                    margin-bottom: 5px;
                }
                .desc_dates{
                    color:#333333;
                    font-size: 15px;
                    margin-bottom: 15px;
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                    flex-wrap: wrap;
                    .operator{
                      
                    } 
                    .hostipal{
                      margin-left:25px;
                    }
                    .dates{

                      margin-left:25px;
                    }
                }
                .desc_content{
                    text-align: left;
                    font-size: 16px;
                    color:#999999;
                    line-height: 31px;
                }
            }
            &:last-child{
                margin-bottom: 0px !important;
            }
        }
    }
}


    .more_s{
          width: 100%;
          text-align: center;
          .more_c{
            display: flex;
            justify-content: center;
            cursor: pointer;
            .more_btn{
              width: 147px;
              height: 49px;
              display: flex;
              justify-content: center;
              align-items: center;
              border-radius: 25px;
              border: solid 2px #4f7cbd;
              color:#2750a2;
              font-size:20px;
              letter-spacing: 2px;
            }
            .more_btn:hover{
              background-color: #4f7cbd !important;
              color:#ffffff !important;
            }
          }
    }


</style>
<style>

</style>


// WEBPACK FOOTER //
// src/view/academicTrends/video.vue